import { forwardRef, useEffect, useState } from 'react';
import { finiteNumberOrNull, percentageStringToNumber } from '../../../../../util';
import { CurrencyInput, CurrencyInputProps } from '../CurrencyInput';
import { InputProps } from '../Input';

export interface HeadlessPercentageInputProps
  extends Pick<InputProps, 'name'>,
    Pick<CurrencyInputProps, 'disabled' | 'onBlur' | 'onFocus'> {
  className?: string;
  placeholder?: string;
  decimalsLimit?: number;
  value?: number | null;
  onChange?: (value: number | null) => void;
}

export const HeadlessPercentageInput = forwardRef<HTMLInputElement, HeadlessPercentageInputProps>(
  ({ name, value, onChange, onBlur, onFocus, placeholder, decimalsLimit = 2, className, disabled }, ref) => {
    const valueString = value === null || value === undefined ? '' : String(value);
    const [localValue, setLocalValue] = useState(valueString);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
      if (!isFocused) {
        setLocalValue(valueString);
      }
    }, [isFocused, valueString]);

    return (
      <CurrencyInput
        ref={ref}
        id={name}
        suffix="%"
        name={name}
        disabled={disabled}
        className={className}
        placeholder={placeholder}
        value={localValue}
        allowNegativeValue={false}
        decimalsLimit={decimalsLimit}
        maxLength={3 + decimalsLimit}
        allowDecimals={decimalsLimit > 0}
        onFocus={(event) => {
          setIsFocused(true);
          onFocus?.(event);
        }}
        onBlur={(event) => {
          setIsFocused(false);
          onBlur?.(event);
        }}
        onValueChange={(rawValue, __, values) => {
          setLocalValue(rawValue ?? '');
          onChange?.(rawValue ? finiteNumberOrNull(values?.float) : null);
        }}
        transformRawValue={(v) => {
          const num = percentageStringToNumber(v);
          if (num === 100 || (num > 100 && !v.includes('.'))) {
            return '100';
          }
          return v;
        }}
      />
    );
  }
);
